/**
 * i18n
 *
 * @author Shigq
 * @date 2021/11/11 14:11
 */
var { createI18n } = require('vue-i18n')
var { utils } = require('@libs/dep-private')

var { commonUtils } = utils

var localeLangZH = require('element-plus/lib/locale/lang/zh-cn')
var localeLangEN = require('element-plus/lib/locale/lang/en')
var zh = require('./lang/zh-cn.json')
var en = require('./lang/en.json')


/* todo - param */
var localeZH = localeLangZH.default
var localeEN = localeLangEN.default

/* todo - constant */
var LOCALE_KEY = 'check-language'
var LANG_DEFAULT = localStorage.getItem(LOCALE_KEY) ? localStorage.getItem(LOCALE_KEY) : localeZH.name

/* todo - methods */
/**
 * assemble messages
 *
 * @param externalMessages
 * @returns {{}}
 */
function _assembleMessages(externalMessages) {
	const messages = {
		[localeZH.name]: Object.assign({}, zh, localeZH),
		[localeEN.name]: Object.assign({}, en, localeEN),
	}

	console.log('externalMessages', externalMessages)

	if (externalMessages) {
		if (externalMessages.zh) {
			messages[localeZH.name] = Object.assign({}, messages[localeZH.name], externalMessages.zh)
		}

		if (externalMessages.en) {
			messages[localeEN.name] = Object.assign({}, messages[localeEN.name], externalMessages.en)
		}
	}

	console.log('messages', messages)

	return messages
}

/**
 * useI18n
 *
 * @description use [i18n] in anywhere
 * @returns {{t: string, switchLang: switchLang, locale: (string|null|*), lang: {}, isLocal: boolean}}
 */
function _useI18n(instance) {
	// console.log('i18n#useI18n', instance)

	instance = instance || getCurrentInstance()

	return {
		t: instance.global.t,
		locale: instance.global.locale,
		messages: instance.global.messages,
		lang: {
			[localeZH.name]: localeZH.name,
			[localeEN.name]: localeEN.name,
		},
		isLocal: instance.global.locale === localeZH.name,
		switchLang: (lang, { reload = false } = {}) => {
			// get default lang from url
			if (!lang) {
				const langUrl = commonUtils.getParamValue(LOCALE_KEY, window.location.href)
				lang = langUrl ? langUrl : LANG_DEFAULT
			}
			// set new lang
			if ([localeZH.name, localeEN.name].includes(lang) && instance.global.locale !== lang) {
				// current lang
				instance.global.locale = lang
				// local lang
				localStorage.setItem(LOCALE_KEY, lang)
				if (reload) {
					window.location.reload()
				}
			}
		}
	};
}

/**
 * init
 *
 * @param options
 */
function getCurrentInstance(options) {
	// console.log('i18n#getCurrentInstance')

	options = options || {
		lang: '',
		message: ''
	}

	const i18n = window.i18n || createI18n({
		locale: options.lang || LANG_DEFAULT,
		fallbackLocale: localeZH.name,
		messages: _assembleMessages(options.messages || '')
	})

	window.i18n = i18n

	return i18n
}

/**
 * install
 *
 * @param app
 */
function install(app, instance) {
	app.use(instance)
}

module.exports = {
	getCurrentInstance,
	useI18n: _useI18n,
	install
}

